import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-6 mb-3" }
const _hoisted_2 = { class: "col-md-6 mb-3" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Clearing ")
const _hoisted_4 = { class: "col-md-6 mb-3" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Bankkontonummer ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectInput = _resolveComponent("SelectInput")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_NumberInput = _resolveComponent("NumberInput")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
    class: "account-info-form-container"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_SelectInput, {
        label: "Bank",
        modelValue: _ctx.form.bankCode,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.bankCode) = $event)),
        empty: "-välj bank-",
        options: _ctx.bankCodeValues
      }, null, 8, ["modelValue", "options"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NumberInput, {
        label: "Clearing",
        accountNumber: true,
        modelValue: _ctx.form.clearingNumber,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.clearingNumber) = $event))
      }, {
        label: _withCtx(() => [
          _hoisted_3,
          _createVNode(_component_Tooltip, { title: "Clearingnummer ska vara 4 eller 5 siffror långt. Brukar vara de första\n        siffrorna i kontonumret. Hos Swedbank är det ofta 5 siffror. Exempel på\n        clearing nummer: 3300, 83279, 81471, 5231, 6162." })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_NumberInput, {
        accountNumber: true,
        modelValue: _ctx.form.accountNumber,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.accountNumber) = $event))
      }, {
        label: _withCtx(() => [
          _hoisted_5,
          _createVNode(_component_Tooltip, { title: "Observera att det måste vara ett konto som är registrerat på dig/er." })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ], 32))
}